import { call, put } from 'redux-saga/effects';
import { requestCreateSkill, requestDeleteSkill, requestEditSkill, requestGetSkill, requestGetSkills, requestGetSkillUsage, requestGetSkillRates, requestSaveSkillRates } from '../requests/skill';
import { showAlert } from '../../slices/alerts';
import { setSkill, setSkills, deleteSkill } from '../../slices/skill';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetSkill(action) {
    try {
        const { skillId } = action.payload;
        const response = yield call(requestGetSkill, skillId);
        yield put(setSkill({ skill: response.data.skill }));
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }))
    }
}

export function* handleGetSkills(action) {
    const { callback } = action.payload || {};
    try {
        const response = yield call(requestGetSkills, true);
        yield put(setSkills({ skills: response.data.skills }));
        if (callback) {
            callback(response.data.skills);
        }
    } catch (error) {
        if (callback) {
            callback(null);
        }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }))
    }
}

export function* handleGetSkillUsage(action) {
    const { callback } = action.payload || {};
    try {
        const response = yield call(requestGetSkillUsage);
        if (callback) {
            callback(response.data.usage);
        }
    } catch (error) {
        if (callback) {
            callback(null);
        }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }))
    }
}

export function* handleGetSkillRates(action) {
    const { callback } = action.payload || {};
    try {
        const { client, account } = action.payload;
        const response = yield call(requestGetSkillRates, client, account);
        if (callback) {
            callback(response.data.rates);
        }
    } catch (error) {
        if (callback) {
            callback(null);
        }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }))
    }
}

export function* handleSaveSkillRates(action) {
    const { callback } = action.payload || {};
    try {
        const { client, account, rates } = action.payload;
        const response = yield call(requestSaveSkillRates, client, account, rates);
        yield put(showAlert({ severity: "success", message: "Special rates saved successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        if (callback) {
            callback(null);
        }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }))
    }
}

export function* handleCreateSkill(action) {
    try {
        const { skillData } = action.payload;
        const response = yield call(requestCreateSkill, skillData);
        yield put(setSkill({ skill: response.data.skill }));
        yield put(showAlert({ severity: "success", message: "Skill created successfully" }));
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }))
    }
}

export function* handleUpdateSkill(action) {
    const { callback } = action.payload;
    try {
        const { skillId, skillData } = action.payload;
        const response = yield call(requestEditSkill, skillId, skillData);
        yield put(setSkill({ skill: response.data.skill }));
        yield put(showAlert({ severity: "success", message: "Skill updated successfully" }));
        if (callback) {
            callback(response.data.skill);
        }
    } catch (error) {
        if (callback) {
            callback(null);
        }
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }))
    }
}

export function* handleDeleteSkill(action) {
    try {
        const { skillId } = action.payload;
        yield call(requestDeleteSkill, skillId);
        yield put(deleteSkill({ skillId }));
        yield put(showAlert({ severity: "success", message: "Skill deleted successfully" }));
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }))
    }
}
